import React from "react";
import { useAppSelector } from "../../../redux/store";
import { useTranslation } from "react-i18next";

const NoFlightsMessage = () => {
  const booking = useAppSelector((state) => state.booking);
  const flights = booking.bookingFlights;
  const { t } = useTranslation();

  return (
    <>
      {!flights || flights.length < 1 ? (
        <p>{t("bookingDetails.flights.noflights")}</p>
      ) : (
        ""
      )}
    </>
  );
};

export default NoFlightsMessage;
